'use strict';

const componentLib = {
  appWide: {
    add: 'Add',
    age: 'Age',
    allDates: 'All Dates',
    at: 'at',
    cancel: 'Cancel',
    confirm: 'Confirm',
    custom: 'Custom',
    date: 'Date',
    dates: {
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        short: {
          january: 'Jan',
          february: 'Feb',
          march: 'Mar',
          april: 'Apr',
          may: 'May',
          june: 'Jun',
          july: 'Jul',
          august: 'Aug',
          september: 'Sep',
          october: 'Oct',
          november: 'Nov',
          december: 'Dec'
        }
      }
    },
    days: 'Days',
    end: 'End',
    goal: 'Goal',
    home: 'Home',
    hours: 'Hours',
    thisWeek: 'This Week',
    thisMonth: 'This Month to Date',
    thisYear: 'This Year to Date',
    nextWeek: 'Next Week',
    reactivation: 'Reactivation',
    nextMonth: 'Next Month',
    lastMonth: 'Last Month',
    lastWeek: 'Last Week',
    lastYear: 'Last Year',
    location: 'Location',
    minutes: 'Minutes',
    months: 'Months',
    new: 'New',
    ordinal: '{day, selectordinal,one {#st} two {#nd} few {#rd} other{#th}}',
    provider: 'Provider',
    remove: 'Remove',
    seconds: 'Seconds',
    send: 'Send',
    start: 'Start',
    time: 'Time',
    today: 'Today',
    weekdays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    },
    weeks: 'Weeks',
    years: 'Years',
    yes: 'Yes',
    no: 'No'
  },
  reviews: {
    recommended: 'Recommended',
    notRecommended: 'Not Recommended'
  },
  attachmentsButton: {
    attachments: 'Add Attachments',
    completed: 'Completed',
    error: 'Upload Error',
    filename: 'File Name',
    size: 'Size',
    uploadProgress: 'Upload Progress'
  },
  currentMonthReviewsGraphic: {
    promoters: 'Promoters',
    neutrals: 'Neutrals',
    detractors: 'Detractors',
    currentMonth: 'Current Month',
    npsScore: 'NPS Score'
  },
  twoToneButton: {
    ariaLabel: 'Full-width contained primary button group'
  },
  monthYearRangePicker: {
    date: 'Date',
    start: 'Start of',
    end: 'End of',
    last: 'Last {amount} {interval}'
  },
  emailStatusBadge: {
    bounce: 'Bounced',
    canceled: 'Canceled',
    click: 'Clicked',
    delay: 'Delayed',
    delivery: 'Delivered',
    failed: 'Failed',
    generation_failure: 'Failed Delivery',
    // eslint-disable-line @typescript-eslint/camelcase
    generation_rejection: 'Failed Delivery',
    // eslint-disable-line @typescript-eslint/camelcase
    invalid: 'Invalid',
    list_unsubscribe: 'Unsubscribed',
    // eslint-disable-line @typescript-eslint/camelcase
    open: 'Opened',
    pending: 'Pending',
    policy_rejection: 'Rejected by Policy',
    // eslint-disable-line @typescript-eslint/camelcase
    sent: 'Sent',
    spam_complaint: 'Marked as Spam' // eslint-disable-line @typescript-eslint/camelcase

  },
  smsStatusBadge: {
    sent: 'Sent',
    failed: 'Failed',
    canceled: 'Canceled',
    received: 'Received',
    invalid: 'Invalid',
    pending: 'Pending'
  },
  appointmentRequestStatusBadge: {
    sentNoResponse: 'Sent - No Response',
    readyForBooking: 'Ready for Booking',
    failed: 'Failed',
    inProgress: 'In Progress',
    sent: 'Sent',
    queued: 'Queued'
  },
  textAudioPreview: {
    apiError: 'Error: Could not play preview.'
  },
  multiSelectWithButtonControl: {
    allSelected: 'All Available Languages Are Selected',
    selectionRequired: 'At least one language must be selected',
    makeDefault: 'Make Default'
  },
  paginationTable: {
    of: 'of',
    results: 'results',
    noResults: 'No Results'
  },
  inputs: {
    multiSelectMenu: {
      reset: 'Reset',
      selectAll: 'Select All'
    },
    datePickerWithDropDownOptions: {
      title: 'Date Range',
      placeholder: 'Date',
      startDateTitle: 'Start Date',
      startDateAriaLabel: 'Change Start Date',
      endDateTitle: 'End Date',
      endDateAriaLabel: 'Change End Date',
      invalidDate: 'Invalid date',
      minDate: 'Date should not be before min date',
      maxDate: 'Date should not be after max date',
      pastDays: 'Past {amount} Days',
      nextDays: 'Next {amount} Days'
    }
  },
  chatInput: {
    pickEmoji: 'Pick Your Emoji'
  },
  activeWeekdayHours: {
    startTime: 'Start Time',
    endTime: 'End Time'
  },
  tables: {
    infiniteScroll: {
      checkSelection: '{selectedCount} of {totalCount} selected'
    }
  },
  addressInput: {
    address: 'Address',
    address1Placeholder: 'Address 1',
    address2Placeholder: 'Address 2',
    cityPlaceholder: 'City',
    statePlaceholder: 'State/Province',
    zipCodePlaceholder: 'Zip/Postal',
    validation: {
      address1: 'Please provide an address.',
      city: 'Please provide a city.',
      state: 'Please select a state or province',
      zipCode: 'Please enter a 5-9 character postal code.'
    }
  },
  validation: {
    isPresent: 'Cannot be left blank'
  },
  conversationList: {
    selectConversation: {
      primaryError: 'Oops, something went wrong',
      secondaryError: 'This might be temporary but if it persists please contact support.',
      noConversationsPrimary: 'No conversations available.',
      noConversationsSecondary: 'Please change your filter options to find your converations!',
      loading: 'Loading Conversations'
    }
  }
};
var en = {
  componentLib
};

module.exports = en;
